export default __webpack_public_path__ + "static/media/Miscellaneous06.0205ba3d.jpg";